import { render, staticRenderFns } from "./privacyPolicy_ar.vue?vue&type=template&id=05983d16&scoped=true&"
import script from "./privacyPolicy_ar.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy_ar.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy_ar.vue?vue&type=style&index=0&id=05983d16&lang=scss&rel=text%2Fcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05983d16",
  null
  
)

export default component.exports